import qs from 'query-string';
export const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        console.log('Text copied to clipboard:', text);
    }
    catch (err) {
        console.error('Unable to copy text to clipboard', err);
    }
};
export const parseUrlSearch = (search) => {
    const s = search ?? window.location.search;
    return (s ? qs.parse(s.replace(/^\?+/, '')) : {});
};
